<template>
  <t-pagination
      :current="pagination.current"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      :default-current="pagination.defaultCurrent"
      :default-page-size="pagination.defaultPageSize"
      @change="handleChange"
  />
</template>

<script setup>
import { onMounted } from "vue";

const props = defineProps({
  pagination: {
    type: Object,
    required: true
  },
  storageKey: {
    type: String,
    required: true
  }
});

const emit = defineEmits(["change"]);

const STORAGE_PREFIX = "table_page_size_";

/** 初始化读取 pageSize */
onMounted(() => {
  const savedSize = localStorage.getItem(STORAGE_PREFIX + props.storageKey);

  if (savedSize) {
    const size = Number(savedSize);

    if (!Number.isNaN(size)) {
      props.pagination.pageSize = size;
    }
  }
});

/** 分页变化 */
const handleChange = (pageInfo) => {
  if (pageInfo.pageSize !== props.pagination.pageSize) {
    localStorage.setItem(
        STORAGE_PREFIX + props.storageKey,
        String(pageInfo.pageSize)
    );
  }

  emit("change", pageInfo);
};
</script>